import { useLocalAuthStore } from '@/stores/local-auth.store';
import type { SignUpData, AuthResult } from '@/stores/local-auth.store';

export type { SignUpData, AuthResult };

/**
 * Local-auth hook exposing the reactive auth state plus all actions,
 * mirroring the Angular `LocalAuthService` public surface.
 */
export function useLocalAuth() {
  const isLoading = useLocalAuthStore((s) => s.isLoading);
  const authError = useLocalAuthStore((s) => s.authError);

  const signUp = useLocalAuthStore((s) => s.signUp);
  const signIn = useLocalAuthStore((s) => s.signIn);
  const signOut = useLocalAuthStore((s) => s.signOut);
  const resetPassword = useLocalAuthStore((s) => s.resetPassword);
  const updatePassword = useLocalAuthStore((s) => s.updatePassword);
  const getSession = useLocalAuthStore((s) => s.getSession);
  const resendVerificationEmail = useLocalAuthStore((s) => s.resendVerificationEmail);

  return {
    isLoading,
    authError,
    signUp,
    signIn,
    signOut,
    resetPassword,
    updatePassword,
    getSession,
    resendVerificationEmail,
  };
}
